export default __webpack_public_path__ + "static/media/32f9dc98a3a17ead32cd5243d48558c11576756350949.c2d712d6.webp";